export enum MassiveCfdiFlags {
  SHOW_UPLOAD_FILE_MODAL,
  SHOW_DOWNLOAD_FILE_MODAL,
  SHOW_CFDI_ERROR_MODAL,
  LOADING_MODAL,
  UPLOAD_FILE,
  CANCEL_DOWNLOAD_CFDI,
  DOWNLOAD_CFDI,
}
